<mat-card>
  <mat-card-header>
    <mat-card-title>
      <h3>{{ formTitle | translate }}</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider class="divider mt-1 mb-2"></mat-divider>
    <form [formGroup]="formGroup">
      <div class="row">
        <!--product id hidden field-->
        <app-form-field
          type="hidden"
          fieldControlName="productId"
          [formGroup]="formGroup"
          [formState]="productForm?.productId"
          col="0"
        ></app-form-field>
        <app-form-field
          type="hidden"
          fieldControlName="active"
          [formGroup]="formGroup"
          [formState]="productForm?.active"
          col="0"
        ></app-form-field>

        <app-form-field
          type="text"
          fieldControlName="prodDesc"
          [formGroup]="formGroup"
          fieldLabel="{{ 'OrganizationDetails.Products.prodDesc' }}"
          col="4"
          [formState]="productForm?.prodDesc"
          [validatorOrOpts]="[Validators.required, Validators.maxLength(50)]"
        ></app-form-field>
        <app-form-field
          type="decimal"
          fieldControlName="productSGU"
          [formGroup]="formGroup"
          fieldLabel="{{ 'OrganizationDetails.Products.productSGU' }}"
          col="2"
          [formState]="productForm?.productSGU"
          [validatorOrOpts]="[Validators.required]"
        ></app-form-field>
        <app-form-field
          type="decimal"
          fieldControlName="coeffExp"
          [formGroup]="formGroup"
          fieldLabel="{{ 'OrganizationDetails.Products.coeffExp' }}"
          col="3"
          [formState]="productForm?.coeffExp"
          [validatorOrOpts]="[
            Validators.required,
            Validators.min(minValue),
            Validators.max(maxValue)
          ]"
        ></app-form-field>
        <app-form-field
          type="text"
          fieldControlName="userProductNumber"
          [formGroup]="formGroup"
          fieldLabel="{{ 'OrganizationDetails.Products.userProductNumber' }}"
          col="3"
          [formState]="productForm?.userProductNumber"
          [validatorOrOpts]="[Validators.maxLength(50)]"
        ></app-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-footer>
    <mat-card-actions>
      <button
        mat-button
        class="cancel-button"
        (click)="onCancelClick()"
        appMaterialElevation
        [defaultElevation]="0"
        [raisedElevation]="1"
        siteUsageTracker
        [logCategory]="'OrganizationDetails-ProductForm'"
        [logName]="'CancelButtonClick'"
        [logData]="orgId"
      >
        {{ 'Dialog.Cancel' | translate }}
      </button>
      <button
        mat-raised-button
        class="add-new-item-button"
        (click)="onSubmit()"
        [disabled]="isSubmitDisabled"
        siteUsageTracker
        [logCategory]="'OrganizationDetails-ProductForm'"
        [logName]="'SubmitButtonClick'"
        [logData]="orgId"
      >
        {{ formTitle | translate }}
      </button>
    </mat-card-actions>
  </mat-card-footer>
</mat-card>
